// The five steps of an event (kitchen flow, Batch 4): Planned → Stock asked →
// Stock here → Cooking → Wrapped up. A thin bar on the Today cards; a strip
// with labels on the plan view. Rules: lib/inventoryFlow/todayLogic.ts.
import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'
import { PLAN_STEPS } from '@/lib/inventoryFlow/todayLogic'
import { TT } from '@/lib/inventoryFlow/todayStrings'

/** Done steps green; the step being waited on amber (only while the store
 *  is still sending); the rest grey. */
export function StepBar({ done, waiting }: { done: number; waiting?: boolean }) {
  const label = PLAN_STEPS[Math.min(Math.max(done, 1), 5) - 1]
  return (
    <div className="mt-2 flex gap-1" role="img" aria-label={`${Math.max(done, 0)} / 5 — ${TT.steps[label]}`}>
      {PLAN_STEPS.map((s, i) => (
        <span key={s} className={cn('h-1 w-10 rounded-full',
          i < done ? 'bg-emerald-600' : i === done && waiting ? 'bg-amber-500' : 'bg-muted-foreground/20')} />
      ))}
    </div>
  )
}

/** The plan view's strip: "1 · Done Planned", "2 · Now Ask the store"… */
export function StepStrip({ done, cancelled }: { done: number; cancelled?: boolean }) {
  return (
    <ol className="grid grid-cols-5 gap-1 rounded-lg border bg-card p-1 text-xs sm:text-sm">
      {PLAN_STEPS.map((s, i) => {
        const isDone = i < done
        const isNow = !cancelled && i === done
        return (
          <li key={s} aria-current={isNow ? 'step' : undefined}
            className={cn('min-w-0 rounded-md px-2 py-2',
              isNow ? 'bg-primary text-primary-foreground' : isDone ? 'text-emerald-700 dark:text-emerald-300' : 'text-muted-foreground')}>
            <span className="flex items-center gap-1 text-xs opacity-80">
              {isDone ? <Check className="h-3 w-3" aria-hidden /> : null}
              {i + 1}{isDone ? ` · ${TT.stepDone}` : isNow ? ` · ${TT.stepNow}` : ''}
            </span>
            <span className="block font-medium leading-tight">{TT.stepsPlan[s]}</span>
          </li>
        )
      })}
    </ol>
  )
}
